import apis from '@apis/index';
import { Image } from '@chakra-ui/react';
import useCart from '@hooks/useCart';
import axios from 'axios';
import { IMenuItems, IYogiyoMenu } from 'interfaces/menu';
import { IYogiyoStore } from 'interfaces/store';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GoPlus } from 'react-icons/go';
import { PulseLoader } from 'react-spinners';
import { setCurrency, setComma } from 'utils/common';

export const fetchCachingedMenu = async (restaurantId: number) => {
  const data = await apis.store.fetchCachingMenus('' + restaurantId);

  return data;
};

export default function RecommendMenu({
  restaurant,
}: {
  restaurant: IYogiyoStore;
}) {
  const [cachingMenu, setCachingMenu] = useState<IYogiyoMenu[] | undefined>();
  const [isLoading, setIsLoading] = useState(true);
  const { setCartMenu, cart } = useCart();
  const { t } = useTranslation('store');

  const handleCachingMenu = async () => {
    setIsLoading(true);
    try {
      const menu = await fetchCachingedMenu(restaurant.id);
      setCachingMenu(menu);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddMenu = (menu: IMenuItems) => {
    const marginPrice = menu.originalPrice;
    setCartMenu({
      restaurant,
      menu: {
        id: menu.id,
        image: menu.image,
        name: menu.name,
        quantity: 1,
        marginPrice,
        marginTotalPrice: marginPrice,
        price: menu.price,
        totalPrice: +menu.price,
        options: [],
        one_dish: menu.one_dish,
        translate_name: menu.translate_name,
        promotionPrice: marginPrice - menu.finalPrice,
        originalPrice: menu.originalPrice,
        finalPrice: menu.finalPrice,
      },
    });
  };
  useEffect(() => {
    handleCachingMenu();
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="min-h-[160px] flex items-center justify-center">
          <PulseLoader color="#e91e63" size="10px" />
        </div>
      ) : (
        cachingMenu && (
          <div>
            <div className="mb-[6px]">
              <strong>{t('recommended_pairs')}</strong>
            </div>
            <div className="overflow-x-auto">
              <ul className="w-fit flex gap-[8px]">
                {cachingMenu.map((item) =>
                  item.items
                    .filter(
                      (_item, index) =>
                        !_item.subchoices.some((sub) => sub.mandatory) &&
                        !cart.menus?.some((_menu) => _menu.id === _item.id),
                    )
                    .map((menu) => (
                      <li
                        key={menu.id}
                        onClick={() => handleAddMenu(menu)}
                        className="relative flex flex-col justify-between gap-[8px] bb br bl bt w-[80px] rounded-md overflow-hidden"
                      >
                        <button className="absolute top-[6px] left-[6px] br bb bl bt rounded-md bg-secondary-200 bg-opacity-30">
                          <GoPlus />
                        </button>
                        <Image w="80px" src={menu.image} />
                        <div className="text-[13px] px-[4px]">
                          <p className="truncate-2">
                            {menu.translate_name || menu.name}
                          </p>
                          {menu.discountRate && menu.discountRate > 0 ? (
                            <>
                              <p className="line-through text-[12px]">
                                {setCurrency(
                                  'kr',
                                  setComma(menu.originalPrice),
                                )}
                              </p>
                              <p className="font-bold">
                                {setCurrency('kr', setComma(menu.finalPrice))}
                              </p>
                            </>
                          ) : (
                            <p className="font-bold">
                              {setCurrency('kr', setComma(menu.originalPrice))}
                            </p>
                          )}
                        </div>
                      </li>
                    )),
                )}
              </ul>
            </div>
          </div>
        )
      )}
    </>
  );
}
